import Section from '../ui/Section'
import { Display, Statement, Body, Points, Em } from '../ui/Type'

const SOURCES = [
  'Documents.',
  'Transactions.',
  'Customer history.',
  'Policies.',
  'Code.',
  'Research.',
  'Databases.',
  'Applications.',
  'Enterprise knowledge.',
]

export default function UnlimitedContext() {
  return (
    <Section id="unlimited-context" label="Unlimited context" tone="tint">
      <Display>Unlimited context.</Display>
      <Statement className="mt-6">Give AI the context the job actually requires.</Statement>

      <Body className="mt-8">Your organization doesn't fit inside a context window. Its intelligence lives across:</Body>
      <Points className="mt-8" cols={2} items={SOURCES} />

      <Body className="mt-14">
        LiquidBrain combines distributed memory and knowledge caching to let AI workloads operate across massive
        information environments.
      </Body>
      <Body className="mt-5">
        <Em>Stop throwing away information just to make the workload fit.</Em>
      </Body>
    </Section>
  )
}
